module.exports = __webpack_public_path__ + "static/media/work-img5.f4094d3a.jpg";